import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.5 15.933c0 .283-.113.555-.314.755-.2.2-.473.312-.757.312H2.57A1.064 1.064 0 0 1 1.5 15.933V2.067c0-.283.113-.555.314-.755.2-.2.473-.312.757-.312h10.747c.28 0 .548.109.748.303l2.11 2.05a1.067 1.067 0 0 1 .324.764v11.816ZM4.746 6.333h8.572M4.746 9.533h8.572M4.746 12.733h4.286",
  stroke: "#0F6378",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }